import React, { createContext, useContext, useState } from 'react';

// Create a context for profile criteria
const SubNavContext = createContext();

// Custom hook to use the SubNavContext
export const useSubNavCriteria = () => useContext(SubNavContext);

// Provider component
export const SubNavCriteriaProvider = ({ children }) => {
  const [subNavCriteria, setSubNanCriteria] = useState(false);

  return (
    <SubNavContext.Provider value={{ subNavCriteria, setSubNanCriteria }}>
      {children}
    </SubNavContext.Provider>
  );
};
